import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Input } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import api from "../../../BrandOnBoarding/api";
import Modal from "../../../Component/Modal/Modal";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { AuthContext } from "../../../context/auth-context";
import { LLM_OPTIONS } from "../../../utils/constant";
import { DiscoveryContext } from "../discovery-context";
import classes from "./HistoryItem.module.css";

export default function HistoryItem({ item, onDelete, onUpdate, setCancelTransaction = () => { },startPolling=()=>{}  }) {
  // const [name, setName] = useState(item?.name || item.entity);
  const [name, setName] = useState(item?.brand);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isError, setIsError] = useState(false);
  const transactionIdRef = useRef();
  const discoveryCtx = useContext(DiscoveryContext);
  const { user } = useContext(AuthContext);
  const webSocketBaseURL = process.env.REACT_APP_ORCHESTRATOR_BASE_URL;

  const statusColors = {
    COMPLETED: "green",
    RETRY: "red",
    DEFAULT: "#FCD34D",
  };

  function deleteHistoryItemHandler() {
    setCancelTransaction(true);
    setShowDeleteDialog(false);
    onDelete(item.transactionId);
  }

  function handleDoneEditing() {
    if (isError) {
      return;
    }
    setIsError(false);
    setIsEditing(false);
    if (
      item.name.toString().toLowerCase().trim() ==
      name.toString().toLowerCase().trim()
    ) {
      return;
    }
    onUpdate(item.id, name);
  }

  function handleInputChange(e) {
    const enteredInput = e.target.value;
    if (enteredInput.trim().length === 0) {
      setIsError(true);
    } else {
      setIsError(false);
    }
    setName(e.target.value);
  }

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      setName(item?.name || item.entity);
      setIsError(false);
      setIsEditing(false);
    }
  };

  useEffect(() => {
    if (discoveryCtx.state.transactionId) {
      transactionIdRef.current = discoveryCtx.state.transactionId;
    }
  }, [discoveryCtx.state.transactionId]);

  let currentBrandSnippets = [];
  let currentBrandThemes = [];
  const coreAttributeMap = {};

  const handleSocketData = (
    socketResponse,
    transaction,
    completedTaskCount
  ) => {
    if (!socketResponse || typeof socketResponse !== "object") {
      console.error("Invalid socket response:", socketResponse);
      return;
    }

    let { type, request, response, category, llm,market, status } = socketResponse;
    let transactionId = transaction?.transactionId;
    if (!type || !request) {
      console.error("Incomplete socket response:", response);
      return;
    }
    if (status !== "COMPLETED") {
      return false;
    }
    const currentContextTxnId = transactionIdRef.current;
    if (transactionId !== currentContextTxnId) return;
    const commonReq = {
      category: category,
      llm: llm,
      market: market,
    };
    console.log("brandAuditHistoryData", socketResponse);
    console.log("completedTaskCountData", completedTaskCount);
    switch (type) {
      case "rank":
        if (!response) return console.warn("Missing response for rank");
        response = { ...response, request_id: socketResponse.id };
        const sorceRank = [
          ...Object.keys(response?.sources?.rank || {}),
        ];
        discoveryCtx.updateRankScores({ req: commonReq, res: response, completedTaskCount });
        discoveryCtx.updateSources({  res: sorceRank, req: commonReq });
        break;

      case "sentiment":
        if (!response || !transaction)
          return console.warn("Missing response/Transaction for sentiment");

        // const entity = response?.data?.[0];
        const entity = { ...response?.data }?.[0];
        const sourceSentiment = [
          ...Object.keys(response?.sources?.sentiment || {}),
        ];
        const brandRes = response?.error
          ? { error: "something went wrong" }
          : {
            name: entity?.name || "Unknown",
            favorability: entity?.score ?? 0,
            extras: response.extras,
            sentimentSources :sourceSentiment
          };
 
        let index = -1;
        try {
          transaction.competitor?.[request.category]?.forEach((item, idx) => {
            if (item.name?.toLowerCase() == entity?.name?.toLowerCase()) {
              index = idx;
            }
          });
          if (transaction.brand === entity?.name) index = -1;
        } catch (err) {
          console.warn("Error calculating sentiment index:", err);
        }

        discoveryCtx.updateBrandScores({
          req: commonReq,
          res: { data: brandRes, index: index + 1 },
          sourceSentiment,
          completedTaskCount
        });
        discoveryCtx.updateSources({ res:sourceSentiment, req: commonReq });
        break;

      case "signalStrength":
        if (!response)
          return console.warn("Missing response for signalStrength");

        const negativeAttributes = response?.aggregatedNegatives || [];
        const positiveAttributes = response?.aggregatedPositives || [];
        const sourcesPosNeg = [
          ...(response?.aggregatedPositiveSources || []),
          ...(response?.aggregatedNegativeSources || []),
        ];

        discoveryCtx.updatePositiveNegativeAttributes({
          res: {
            name: socketResponse.brand,
            positives: positiveAttributes.slice(0, 10),
            negatives: negativeAttributes.slice(0, 10),
          },
          req: commonReq,
          completedTaskCount,
        });

        discoveryCtx.updateSources({ res: sourcesPosNeg, req: commonReq });
        break;

      case "categoryDimension":
        if (!response)
          return console.warn("Missing response for categoryDimension");

        discoveryCtx.updateCategoryDimensions({
          data: response?.data,
          summary: response?.summary,
          category: request?.category,
          llm: request?.llm,
          completedTaskCount,
        });

        const sourcesCategoryDim = [
          ...Object.keys(response?.sources?.category || {}),
          ...Object.keys(response?.sources?.dimension || {}),
        ];

        discoveryCtx.updateSources({ res: sourcesCategoryDim, req: commonReq });
        break;

      case "taxonomy":
        if (!response) return console.warn("Missing response for taxonomy");
        discoveryCtx.updatedTaxonomies({
          res: response.data,
          req: {
            category: category,
            llm: llm,
          },
          completedTaskCount,
        });
        break;

      case "core-attribute":
        if (!response || !category || !llm)
          return console.warn("Missing data for core-attribute");
        const key = `${llm}__${category}`;

        if (!coreAttributeMap[key]) {
          coreAttributeMap[key] = [];
        }

        coreAttributeMap[key].push(response);
        let competitors = transaction?.competitor?.[category]?.map(
          (item) => item.name
        );
        let brand = transaction?.competitor?.["default"]?.[0].name;
        if (competitors) {
          competitors.unshift(brand);
        } else {
          competitors = [];
        }
        console.log("coreAttributeMap", competitors, coreAttributeMap[key]);
        if (coreAttributeMap[key].length === 4) {
          const group = coreAttributeMap[key];
          let coreAttributeSummary = "";
          const products = [];
          const sources = [];

          const category_averages = group[0]?.category_averages;

          for (const res of group) {
            if (!res?.error && Array.isArray(res?.products)) {
              coreAttributeSummary += res.products?.[0]?.summary || "";
              coreAttributeSummary += "\n\n";
              products.push(res.products?.[0]);
              sources.push(
                ...Object.keys(res?.sources?.category || {}),
                ...Object.keys(res?.sources?.product || {})
              );
            }
          }

          let sortedProducts = [];

          for (const company of competitors) {
            const normalizedCompany = company.toLowerCase().replace(/\s+/g, "");
            for (const product of products) {
              const normalizedProductName = product.name
                .toLowerCase()
                .replace(/\s+/g, "");
              if (normalizedProductName === normalizedCompany) {
                sortedProducts.push(product);
                break;
              }
            }
          }

          discoveryCtx.updateCoreAttributes({
            category_averages,
            products: sortedProducts,
            summary: coreAttributeSummary,
            category,
            llm,
            completedTaskCount,
          });

          discoveryCtx.updateSources({ res: sources, req: commonReq });

          delete coreAttributeMap[key];
        }
        break;
      case "description":
        if (!response?.data)
          return console.warn("Missing response.data for description");
        discoveryCtx.updateBrandDescription({
          res: response.data,
          req: { category: category, llm: llm },
          completedTaskCount,
        });
        break;

      case "theme":
      case "snippet": {
        const isTheme = type === "theme";
        const dataSnippet = response?.data?.data;

        if (!Array.isArray(dataSnippet)) {
          console.warn(`${type} response is not a valid array:`, dataSnippet);
          return;
        }

        if (!llm || !category) {
          console.warn("Missing llm/category for", type);
          return;
        }

        const targetStore = isTheme ? currentBrandSnippets : currentBrandThemes;
        const contextMethod = isTheme
          ? discoveryCtx.updateBrandSnippets
          : discoveryCtx.updatedBrandThemes;

        if (!targetStore[llm]) targetStore[llm] = {};
        if (!targetStore[llm][category]) targetStore[llm][category] = [];

        // Append entire array as a sub-array
        targetStore[llm][category] = [
          ...targetStore[llm][category],
          dataSnippet,
        ];
        contextMethod({
          res: targetStore[llm][category],
          req: { category, llm },
          completedTaskCount,
        });

        break;
      }

      default:
        console.warn(`Unhandled socket data type: ${type}`);
    }
  };

  const getTransactionData = async (transactionRecord) => {
    let transactionId = transactionRecord.transactionId;
    discoveryCtx.resetState();
    discoveryCtx.updateTransactionId(transactionId);
    discoveryCtx.cancelSelection();

    discoveryCtx.updateEntity(transactionRecord.brand);
    let competitors = transactionRecord.competitor;
    competitors["default"] = [
      {
        name: transactionRecord.brand,
        domain: transactionRecord.brandDomainName,
        variants: [],
        display_name: transactionRecord.brand,
      },
    ];
    discoveryCtx.updatedCompetitors(competitors);
    discoveryCtx.updateMarket(
      transactionRecord.market.length > 0
        ? transactionRecord.market
        : ["GeneralMarket"]
    );
    console.log("transactionRecord", transactionRecord);
    discoveryCtx.updateCategory(transactionRecord.category);
    discoveryCtx.updateSelectedLLM(transactionRecord.primaryLLM);
    discoveryCtx.updateSelectedMarket(transactionRecord.market[0]);
    discoveryCtx.updateSelectedCategory(transactionRecord.category[0]);
    discoveryCtx.updateLLM(transactionRecord.llm);
    // fix domain issue later
    discoveryCtx.updateName(`${transactionRecord.brand} Brand Overview`);
    discoveryCtx.updatePrimaryLLM(transactionRecord.primaryLLM);

    discoveryCtx.updateId(transactionId);
    discoveryCtx.updatedLaunched(true);
    discoveryCtx.updateTransactionStatus(transactionRecord.status);
    discoveryCtx.initializeStatus();
    if (transactionRecord.status === "COMPLETED") {
      discoveryCtx.updateLoading(false);
    } else {
      discoveryCtx.updateLoading(true);
    }

    setTimeout(() => {
      api
        .get(
          `${webSocketBaseURL}/brandAudit/${user.customer_id}/${transactionId}`
        )
        .then((response) => {
          const completedTaskCount = response.data.completedTaskCount;
        if(response?.data?.transactionStatus === "RUNNING"){
          startPolling(transactionId,discoveryCtx.type);
        }
          for (const record of response.data.task) {
            handleSocketData(record, transactionRecord, completedTaskCount);
          }
        });
    }, 1000);
  };

const formatDateTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  return date.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, 
  });
};


  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  const type = discoveryCtx.type ?? "brand";
  // const llmName =
  //   LLM_OPTIONS.find((option) => option.value === item?.llm)?.name || "GPT-4o";
  const llmName =
    LLM_OPTIONS.find((option) => option.value === item?.primaryLLM)?.name ||
    "GPT-4o";

   const startDateTime = formatDateTime(item?.start_time);

  return (
    <div
      className={classes.container}
      style={{
        borderLeft: `4px solid ${
          statusColors[item.status] || statusColors.DEFAULT
        }`,
      }}
    >
      <Modal
        handleClose={() => setShowDeleteDialog(false)}
        handleConfirm={deleteHistoryItemHandler}
        open={showDeleteDialog}
        title="Delete History?"
        showActions
        confirmBtnText="Delete"
        confirmBtnColor="error"
      >
        Do you want to delete this item - {name}?
      </Modal>
      <div className={classes.text_container}>
        <TextsmsOutlinedIcon />
        {!isEditing && (
          <div>
            <span title={item.name} className={classes.text}>
              {`${item.brand} ${capitalize(type)} Overview`}
            </span>
            <div className={classes.meta}>
              <span className={classes.sub_text} title={item?.category[0]}>
                {item?.category[0]}
              </span>
              <span>&middot;</span>
              {item?.market[0] && (
                <>
                  <span className={classes.sub_text} title={item?.market[0]}>
                    {item?.market[0] == "GeneralMarket" ? "General Market" : item?.market[0]}
                  </span>
                  <span>&middot;</span>
                </>
              )}
              <span className={classes.sub_text} title={llmName}>
                {llmName}
              </span>
               <span className={classes.sub_text} title={startDateTime}>
                {startDateTime}
              </span>
            </div>
          </div>
        )}
        {isEditing && (
          <Input
            disableUnderline
            className={classes.input}
            style={{ borderColor: isError ? "red" : "gray" }}
            type="text"
            value={name}
            onKeyDown={handleKeyDown}
            onChange={handleInputChange}
          />
        )}
      </div>
      <div className={classes.action}>
        {!isEditing && (
          <>
            <MUIIconButton
              sx={{ color: "#000" }}
              onClick={() => getTransactionData(item)}
            >
              <VisibilityOutlinedIcon />
            </MUIIconButton>
            <MUIIconButton
              sx={{ color: "#000" }}
              onClick={() => setShowDeleteDialog(true)}
            >
              <DeleteOutlineOutlinedIcon />
            </MUIIconButton>
          </>
        )}
        {isEditing && (
          <MUIIconButton onClick={handleDoneEditing}>
            <DoneOutlinedIcon />
          </MUIIconButton>
        )}
      </div>
    </div>
  );
}
